export const capitalizeEachWord = (s: string) =>
  s
    .trim()
    .replace(/\s+/g, ' ')
    .replace(
      /[^-\s]+/g,
      (w) => `${w.slice(0, 1).toUpperCase()}${w.slice(1).toLowerCase()}`
    )

export const capitalizeFirstLetter = (s: string): string =>
  s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()

export const formatFirstNameAndLastName = (
  firstname: string,
  lastName: string
): string => {
  const formattedFirstName =
    firstname.charAt(0).toUpperCase() + firstname.slice(1).toLowerCase()
  const formattedLastName = lastName.toUpperCase()

  return `${formattedFirstName} ${formattedLastName}`
}

export const compareNormalizedString = (s1: string, s2: string): boolean =>
  s1.normalize('NFD').toLowerCase().replace(/\s+/g, '') ===
  s2.normalize('NFD').toLowerCase().replace(/\s+/g, '')

export function toKebabCase(input: string): string {
  return input
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
    .replace(/--+/g, '-')
}

export function replaceMarkdownEmptyParagraphs(input: string): string {
  return input
    .replace(/\n\n  \n\n/g, '\n\n&nbsp;\n\n')
    .replace(/\n  \n/g, '\n\n&nbsp;\n\n')
}

function normalizeString(input: string): string {
  return input
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}

export function includesNormalizedString(s1: string, s2: string): boolean {
  return normalizeString(s1).includes(normalizeString(s2)) || false
}

export function typedLowerCase<T extends string>(input: T): Lowercase<T> {
  return input.toLowerCase() as Lowercase<T>
}
